export default {
  title: 'Reactivar tutorial de navegación',
  message: 'Al reactivarlo, podrás ver una vez más el recorrido de navegación.',
  activate: 'Activar'
}

export const en = {
  title: 'Reactivate navigation tutorial',
  message: 'By reactivating it, you will be able to see the navigation tutorial once again.',
  activate: 'Activate'
}

export const ca = {
  title: 'Reactivar tutorial de navegació',
  message: 'En reactivar-lo, podràs veure una vegada més el recorregut de navegació',
  activate: 'Activar'
}
